<template>
    <footer class="layout-footer">
        <div>
            <a href="https://green-code.studio/" @click.prevent>Made by It-Solve/Green Code Studio</a>
        </div>
        <div>
            <template v-if="isAdmin">
                <router-link v-for="(x,i) in logsLinks" :key="i"
                             :to="{path:'/log', query:{objectType:x.objectType, id:x.id}}">
                    <span class="ion-md-albums"/>
                </router-link>
                <router-link v-for="(x,i) in viewsLinks" :key="i"
                             :to="{path:'/viewed', query:{objectType:x.objectType, id:x.id}}">
                    <span class="ion-md-eye"/>
                </router-link>
            </template>
            Version {{ version }} (last update: {{ lastUpdate }})
        </div>
    </footer>
</template>
<script>
import {__BUILD_COMMIT_HASH__, __BUILD_DATE__} from "../../../version";
import datetime from "@/common/mixins/datetime";
import objectDefinitions from "@/common/objectDefinitions";

export default {
    name: "LayoutFooter",
    mixins: [datetime],
    props: {
        currentObjectDetails: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        version() {
            return __BUILD_COMMIT_HASH__.slice(0, 7);
        },
        lastUpdate() {
            try {
                return this.formatDateTime(this.stringToDate(__BUILD_DATE__));
            } catch (ex) {
                return '-';
            }
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        logsLinks(){
            return this.currentObjectDetails;
        },
        viewsLinks(){
            return this.currentObjectDetails.filter(x=>objectDefinitions.definition[x.objectType].hasViewsLog);
        }
    }
}
</script>
